import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import SkillsTemp from "./SkillTemp/SkillTemp";
import { skills as skillsText } from "../../../assets/text/SkillsText";
import { Element } from "react-scroll";
import BackgroundEffects from "../../UI/BackgroundEffects/BackgroundEffects";
import classes from "./Skill.module.css";

const Skill = () => {
  const sectionRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });

  // Heading slides in from right with parallax
  const headingX = useTransform(scrollYProgress, [0, 0.3], [60, 0]);
  const headingOpacity = useTransform(scrollYProgress, [0, 0.25], [0, 1]);

  const skillVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.5, ease: [0.4, 0, 0.2, 1] },
    },
  };

  return (
    <Element name="Skills" className={classes.SkillContainer} ref={sectionRef}>
      <BackgroundEffects variant="skills" />
      <motion.div
        className={classes.SkillHeading}
      >
        <h1>My Skills</h1>
        <p className={classes.SkillTagline}>Modern skills for modern websites</p>
        <p className={classes.SkillWriteup}>
          Over the years I have worked with a wide range of technologies across
          the full web stack — from crafting pixel-perfect, responsive
          interfaces with React and modern CSS, to building scalable backends
          with Node.js, PHP and cloud platforms. This toolbox lets me pick the
          right tool for every project and ship fast, reliable and maintainable
          products.
        </p>
      </motion.div>

      <motion.div
        className={classes.SkillsGrid}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
        variants={{
          hidden: {},
          visible: {
            transition: { staggerChildren: 0.08 },
          },
        }}
      >
        {Object.entries(skillsText).map(([name, icon]) => (
          <motion.div
            key={name}
            variants={skillVariants}
          >
            <SkillsTemp name={name} icon={icon} />
          </motion.div>
        ))}
      </motion.div>
    </Element>
  );
};

export default Skill;
